"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        paddingTop: 2,
        paddingBottom: 2,
        maxHeight: 'inherit'
    },
    menu: {
        listStyle: 'none',
        paddingLeft: 0,
        backgroundColor: theme.grey8,
        borderRadius: 2,
        boxShadow: `inset 0 0 0 1px ${theme.grey5}, 2px 3px 10px 0 rgba(0,0,0,0.1)`,
        overflow: 'auto',
        outline: 'none',
        maxHeight: 'inherit'
    }
});
//# sourceMappingURL=popover.menu.style.js.map